import { complement, filter, flatten, isEmpty, join, map, pipe, split } from 'ramda'

const isNotEmpty = complement(isEmpty)

export const pathTo = (...paths: string[]) =>
  pipe(map(split('/')), flatten, filter(isNotEmpty), (arr) => ['', ...arr], join('/'))(paths)
